import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Lock } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

export const ToolCard = ({ tool }) => {
  const IconComponent = tool.icon;

  return (
    <Link to={tool.path} className="group">
      <div className="glass-card p-6 h-full flex flex-col transition-smooth hover:scale-[1.02]">
        {/* Icon & Badge */}
        <div className="flex items-start justify-between mb-4">
          <div className="p-3 glass rounded-lg group-hover:glow-primary transition-smooth">
            <IconComponent className="w-6 h-6 text-primary" />
          </div>
          {tool.featured && (
            <Badge variant="secondary" className="text-xs">
              Popular
            </Badge>
          )}
        </div>

        {/* Content */}
        <div className="flex-grow">
          <h3 className="text-xl font-semibold mb-2 group-hover:text-primary transition-smooth">
            {tool.name}
          </h3>
          <p className="text-muted-foreground text-sm leading-relaxed">
            {tool.description}
          </p>
        </div>

        {/* Privacy Badge */}
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-border/50">
          <div className="flex items-center space-x-2 text-xs text-muted-foreground">
            <Lock className="w-3 h-3" />
            <span>100% Private</span>
          </div>
          <ArrowRight className="w-4 h-4 text-primary group-hover:translate-x-1 transition-smooth" />
        </div>
      </div>
    </Link>
  );
};

export default ToolCard;
